const map_style = [
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#196ac1"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f1f7fd"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#c7def8"
      }
    ]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#c7def8"
      }
    ]
  },
  {
    "featureType": "landscape.natural",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#c7def8"
      }
    ]
  },
  {
    "featureType": "landscape.natural.landcover",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#bcd8f6"
      }
    ]
  },
  {
    "featureType": "landscape.natural.terrain",
    "stylers": [
      {
        "color": "#c7def8"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#b3d3f5"
      }
    ]
  },
  {
    "featureType": "poi.business",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#b3d3f5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.place_of_worship",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#b3d3f5"
      }
    ]
  },
  {
    "featureType": "poi.school",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#b3d3f5"
      }
    ]
  },
  {
    "featureType": "poi.sports_complex",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#b3d3f5"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#f3f8fd"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#b9d5f3"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#f3f8fd"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#b9d5f3"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#f3f8fd"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#b9d5f3"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#daebff"
      }
    ]
  },
  {
    "featureType": "water",
    "stylers": [
      {
        "color": "#9ec5ef"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#9ec5ef"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#77b0e9"
      }
    ]
  }
];

function onSearchCallback () {
  const filterBtns = document.querySelectorAll(".partner-locator .modal .filter-btn");
  if (filterBtns) {
    let filter = {};
    filterBtns.forEach((btn) => {
      if (btn.classList.contains('active-filter-btn')) {
        filter[btn.dataset.cat] = true;
      }
    })
    storeLocatorGoogleMap.filterMarkers(filter);
  }
}

const categoryBtn = document.querySelector(".partner-locator .category-btn");
if (categoryBtn) {
  categoryBtn.addEventListener("click", () => {
    categoryBtn.classList.toggle("active-filter-btn");
    const icons = categoryBtn.getElementsByClassName(
      "icon-arrow-cta-right-blue-pei"
    );
    if (tabMap.classList.contains("active")) {
      categoryBtn
        .closest(".complex-search")
        .classList.toggle("non-rounded-borders");
    }
    icons[0].classList.toggle("icon-close-blue-bapr-14");

    document.body.style.overflow = "visible";
  });
}

const map = document.querySelector(".partner-locator .map");
const tabs = document.querySelectorAll(".partner-locator .nav-link");

const tabMap = document.querySelector(".partner-locator .nav-map");
const modal = document.querySelector(".partner-locator #desktopModal.modal");

if (tabMap) {
  window.addEventListener("load", () => {
    map.classList.add("map-active");
  });
}

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    if (tabMap.classList.contains("active")) {
      map.classList.add("map-active");
      modal.classList.remove("relative-positioned");
    } else {
      map.classList.remove("map-active");
      modal.classList.add("relative-positioned");
      modal.closest(".complex-search").classList.add("non-rounded-borders");
    }
  });
});

const filterBtns = document.querySelectorAll(".partner-locator .modal .filter-btn");
if (filterBtns) {
  filterBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      btn.classList.toggle("active-filter-btn");
    });
  });
}

const clearFilterBtn = document.querySelector('.partner-locator .btn.btn-outline-primary.reset-btn');
if (clearFilterBtn) {
  clearFilterBtn.addEventListener("click", () => {
    filterBtns.forEach((btn) => {
      btn.classList.remove('active-filter-btn');
    });
    // reset near me button
    const nearMeBtnIcon = document.querySelector('.partner-locator #btn-near-me i');
    if (nearMeBtn) {
      if (!nearMeBtn.classList.contains('btn-outline-primary')) {
        nearMeBtn.classList.remove('btn-primary');
        nearMeBtn.classList.remove('btn-active');
        nearMeBtn.classList.add('btn-outline-primary');
        nearMeBtnIcon.classList.remove('icon-poi-pin-white');
        nearMeBtnIcon.classList.add('icon-poi-pin-blue-pei');
      }
    }
    // reset search text
    const searchText = document.getElementById('partner-search-box');
    if (searchText) {
      searchText.value = '';
    }
    storeLocatorGoogleMap.filterMarkers({});
  });
}

const searchBtn = document.querySelector('.partner-locator .btn.btn-tertiary.save-btn');
if (searchBtn) {
  searchBtn.addEventListener("click", () => {
    onSearchCallback();
  });
}

const nearMeBtn = document.querySelector('.partner-locator #btn-near-me');
if (nearMeBtn) {
  nearMeBtn.addEventListener("click", () => {
    const nearMeBtnIcon = document.querySelector('.partner-locator #btn-near-me i');
    if (nearMeBtn.classList.contains('btn-outline-primary')) {
      nearMeBtn.classList.remove('btn-outline-primary');
      nearMeBtn.classList.add('btn-primary');
      nearMeBtn.classList.add('btn-active');
      nearMeBtnIcon.classList.remove('icon-poi-pin-blue-pei');
      nearMeBtnIcon.classList.add('icon-poi-pin-white');
    } else {
      nearMeBtn.classList.remove('btn-primary');
      nearMeBtn.classList.remove('btn-active');
      nearMeBtn.classList.add('btn-outline-primary');
      nearMeBtnIcon.classList.remove('icon-poi-pin-white');
      nearMeBtnIcon.classList.add('icon-poi-pin-blue-pei');
    }
  });
}

const searchInputText = document.getElementById('partner-search-box'); 
if (searchInputText) {
  searchInputText.addEventListener("search", () => {
    onSearchCallback();
  })
}

if (map) {
  document.addEventListener("DOMContentLoaded", () => {
    window.storeLocatorGoogleMap = storeLocatorGoogleMap;

    if(!navigator.geolocation) {
      // Error
      console.debug('PARTNER NAV Geolocation not supported');
      window.storeLocatorGoogleMap.init(new google.maps.LatLng("36.9148356", "14.7220462"));
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        // Success
        const latitude  = position.coords.latitude.toString();
        const longitude = position.coords.longitude.toString();
        console.debug('PARTNER NAV Get user position at lat:'+latitude+' lng: '+longitude);
        window.storeLocatorGoogleMap.init(new google.maps.LatLng(latitude, longitude));
      }, () => {
        // Error
        console.debug('PARTNER NAV Unable to get user position');
        window.storeLocatorGoogleMap.init(new google.maps.LatLng("36.9148356", "14.7220462"));
      });
    }
  });
}
var googleDefined = false;
if (typeof google !== 'undefined') {
  googleDefined = true;
}
const storeLocatorGoogleMap = {
  iconBlue: "/wp-content/themes/bapr2021/assets/images/baprs_maps_pin_selected.png",
  iconWhite: "/wp-content/themes/bapr2021/assets/images/baprs_maps_pin_unselected.png",
  bounds: googleDefined ? new google.maps.LatLngBounds(): null,
  map: null,
  customerPos: null,
  markerPrev: null,
  infoWindow: googleDefined ? new google.maps.InfoWindow(): null,

  attachListeners: function () {
    this.mapView();
  },

  init: function (position) {
    console.log("PARTNER MAP INIT");
    this.customerPos = position;
    this.attachListeners();
  },

  getInfoWindowContent: function(m) {
    const contentString = document.querySelector('#poi-modal-container #poi-modal-'+m._id).innerHTML;
    return contentString;
  },

  loadMarkers: function() {
    //load data from api
    fetch('/wp-json/bapr/v1/partner')  
      .then(response => response.json())
      .then((data) => {
        console.log("data da partner", data)
        data.forEach((ele) => {  
          // Add marker into bounds
          this.bounds.extend({'lat': parseFloat(ele['lat']), 'lng':parseFloat(ele['lng'])});
          let latlng = new google.maps.LatLng(parseFloat(ele['lat']), parseFloat(ele['lng']));
          // create marker
          let marker = new google.maps.Marker({
            position: latlng,
            map: this.map,
            icon: this.iconWhite,
            title: ele['name'],
            _cats: 'p-cat-'+ele['cats'],
            _full_text: ele['_full_text'],
            _id: ele['id'],
          });

          // marker click event
          google.maps.event.addListener(marker, 'click', (function (marker, that) {
            return function () {
              that.infoWindow.setContent(that.getInfoWindowContent(marker).replace('\n','').replace('\t', ''));
              if (that.markerPrev) {
                that.markerPrev.setIcon(that.iconWhite);
              }
              marker.setIcon(that.iconBlue);
              that.infoWindow.open(that.map, marker);
              that.markerPrev = marker;
            }
          })(marker, this))

          // add marker to map
          this.map.markers.push(marker);
        });

        this.fitBounds(true);
      });
  },

  hideTitleList: function(childClass) {
    const parentId = '#p-list-state' + childClass.split('-').pop();
    const selector = parentId+' .'+childClass;
    const children = document.querySelectorAll(selector);
    let child_counter = children.length;
    children.forEach((child) => {
      if (child.classList.contains('d-none')) {
        child_counter -= 1;
      }
    });
    if (child_counter === 0) {
      document.querySelector(parentId).classList.add('d-none');
    }
  },

  showTitleList: function(childClass) {
    const parentId = '#p-list-state' + childClass.split('-').pop();
    const selector = parentId+' .'+childClass;
    const children = document.querySelectorAll(selector);
    let child_counter = children.length;
    children.forEach((child) => {
      if (child.classList.contains('d-none')) {
        child_counter -= 1;
      }
    });
    if (child_counter !== 0) {
      document.querySelector(parentId).classList.remove('d-none');
    }
  },

  hideElementFromList: function(id) {
    let parent_id;
    let element = document.querySelector('#nav-tabContent #poi-'+id);
    element.classList.add('d-none');
    element.classList.forEach((e_class) => {
      if (e_class.includes('child-of-')) {
        parent_id = e_class;
        return;
      }
    });
    this.hideTitleList(parent_id);
  },

  showElementFromList: function(id) {
    let parent_id;
    let element = document.querySelector('#nav-tabContent #poi-'+id);
    element.classList.remove('d-none');
    element.classList.forEach((e_class) => {
      if (e_class.includes('child-of-')) {
        parent_id = e_class;
        return;
      }
    });
    this.showTitleList(parent_id);
  },

  resetBounds: function() {
    // Reset bounds to visible markers
    this.bounds = new google.maps.LatLngBounds();
    this.map.markers.forEach((e) => {
      if (e.getVisible()) {
        this.bounds.extend({'lat': e.position.lat(), 'lng': e.position.lng()});
      }
    });
  },

  fitBounds: function(flag = true) {
    // Zoom map to bounds
    if (flag) {
      this.resetBounds();
    }
    this.bounds.extend(this.customerPos);
    this.map.setCenter(this.bounds.getCenter());
    this.map.fitBounds(this.bounds);
    this.map.panToBounds(this.bounds);
  },

  rad: function(x) {
    return x*Math.PI/180;
  },

  findClosestMarkers: function(nElements = 10) {
    let closest = [];
    const R = 6371; // radius of earth in km
    let lat = this.customerPos.lat();
    let lng = this.customerPos.lng();

    for (i = 0; i < this.map.markers.length; i++) {
      // if maker is visible
      if (this.map.markers[i].getVisible()) {
        // Calculate the distance from pos and the marker     
        let mlat = this.map.markers[i].position.lat();
        let mlng = this.map.markers[i].position.lng();
        let dLat  = this.rad(mlat - lat);
        let dLong = this.rad(mlng - lng);
        let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(this.rad(lat)) * Math.cos(this.rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        let d = R * c;
        let m = {
          '_id': this.map.markers[i]._id,
          'distance': d
        };

        if (closest.length < nElements) {
          // add marker to array
          closest.push(m);
        } else {
          // check if marker is one of the most closest
          const max = closest.reduce((prev, current) => (prev.distance > current.distance) ? prev : current);
          if (d < max.distance) {
            closest = $.grep(closest, function(e){ 
              return e._id != max._id; 
            });
            closest.push(m);
          } 
        }
      }
    }
    // return an array of maker id
    return closest.map(item => item._id);
  },

  findTextMarker: function() {
    const searchText = document.getElementById('partner-search-box').value.toLowerCase();
    let out = [];
    for (i = 0; i < this.map.markers.length; i++){
      if (this.map.markers[i].getVisible()){
        if (this.map.markers[i]._full_text.toLowerCase().includes(searchText)) {
          out.push(this.map.markers[i]._id);
        }
      }
    }
    return out;
  },

  filterMarkers: function(filter) {
    if (Object.keys(filter).length === 0) {
      // show all
      let that = this;
      this.map.markers.forEach(function(e){
        e.setVisible(true);
        // Show list element
        that.showElementFromList(e._id);
      },(this));
    } else {
      //let that = this;
      this.map.markers.forEach(function(e){
        // Check if a marker must be visible
        if (e._cats in filter) {
          e.setVisible(true);
          // Show list element
          this.showElementFromList(e._id);
        } else {
          e.setVisible(false);
          // Hide list element
          this.hideElementFromList(e._id);
        }
      },(this));
    }
    let nearMeBtn = document.querySelector('.partner-locator #btn-near-me');
    if (nearMeBtn.classList.contains('btn-active')) {
      this.showClosestMarker();
    }
    let searchText = document.getElementById('partner-search-box');
    if (searchText != '') {
      this.showTextMarker();
    }
    this.fitBounds(true);
  },

  showClosestMarker: function() {
    let toShow = this.findClosestMarkers();
    // Check if a marker must be visible
    this.map.markers.forEach((e) => {
      if (toShow.includes(e._id)) {
        e.setVisible(true);
        // Show list element
        this.showElementFromList(e._id);
      } else {
        e.setVisible(false);
        // Hide list element
        this.hideElementFromList(e._id);
      }
    },(this))
  },

  showTextMarker: function() {
    let toShow = this.findTextMarker();
    // Check if a marker must be visible
    this.map.markers.forEach((e) => {
      if (toShow.includes(e._id)) {
        e.setVisible(true);
        // Show list element
        this.showElementFromList(e._id);
      } else {
        e.setVisible(false);
        // Hide list element
        this.hideElementFromList(e._id);
      }
    },(this))
  },

  mapView: function() {
    this.map = new google.maps.Map( $('.map')[0], {
      center: this.customerPos,
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: map_style,
    });

    this.map.markers = [];

    // infoWindow close event
    google.maps.event.addListener(this.infoWindow,'closeclick',(function(infowindow, that) {
      return function() {
        if (that.markerPrev) {
          that.markerPrev.setIcon(that.iconWhite);
        }
      }
    })(this.infoWindow, this));

    this.loadMarkers();
  },

}